/* sm-about-tabs — port of Manukora multi-slider-tabs.js on Swiper 11.
   Tabs: desktop = static pills; mobile (<768) = centered, looping, slidesPerView auto, spaceBetween 26.
   Images + content: fade/crossFade, loop on mobile. All three stay in sync; tab click / Next button / swipe drive it. */
(function () {
  function isMobile() { return window.innerWidth < 768; }
  function init(root) {
    if (root.dataset.smInit || !window.Swiper) return;
    root.dataset.smInit = '1';
    var tabsEl = root.querySelector('[data-sm-tabs]'), imgEl = root.querySelector('[data-sm-images]'), conEl = root.querySelector('[data-sm-content]');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('.sm-about-tabs__tab'));
    var count = tabs.length; if (!count) return;
    var tabsSw = null, imgSw = null, conSw = null, syncing = false, mobile = null;
    function real(sw) { return sw.realIndex !== undefined ? sw.realIndex : sw.activeIndex; }
    function go(sw, i) { if (!sw) return; if (sw.params.loop) sw.slideToLoop(i); else sw.slideTo(i); }
    function sync(i, from) {
      if (syncing) return; syncing = true;
      i = ((i % count) + count) % count;
      if (from !== 'images') go(imgSw, i);
      if (from !== 'content') go(conSw, i);
      if (from !== 'tabs') go(tabsSw, i);
      root.querySelectorAll('.sm-about-tabs__tab').forEach(function (t) { var on = Number(t.dataset.slide) === i; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
      root.querySelectorAll('[data-sm-current]').forEach(function (c) { c.textContent = i + 1; });
      setTimeout(function () { syncing = false; }, 50);
    }
    function build() {
      var m = isMobile(); if (m === mobile) return; mobile = m;
      [tabsSw, imgSw, conSw].forEach(function (s) { if (s) s.destroy(true, true); });
      var loop = m && count > 2;
      // Manukora clones the tab slides once on mobile so Swiper's loop has enough slides for the centered strip
      var wrap = tabsEl.querySelector('.swiper-wrapper');
      wrap.querySelectorAll('.is-clone').forEach(function (n) { n.remove(); });
      if (loop) Array.prototype.slice.call(wrap.children).forEach(function (sl) { var c = sl.cloneNode(true); c.classList.add('is-clone'); c.querySelectorAll('[id]').forEach(function (n) { n.removeAttribute('id'); }); wrap.appendChild(c); });
      tabsSw = (count > 2) ? new window.Swiper(tabsEl, { slidesPerView: 'auto', spaceBetween: m ? 26 : 0, centeredSlides: m, loop: loop, watchSlidesProgress: true, allowTouchMove: m }) : null;
      imgSw = new window.Swiper(imgEl, { slidesPerView: 1, spaceBetween: 0, effect: 'fade', fadeEffect: { crossFade: true }, loop: loop, allowTouchMove: true });
      conSw = new window.Swiper(conEl, { slidesPerView: 1, spaceBetween: 0, effect: 'fade', fadeEffect: { crossFade: true }, loop: loop, allowTouchMove: true });
      if (tabsSw) tabsSw.on('slideChange', function () { if (m) sync(real(this), 'tabs'); });
      imgSw.on('slideChange', function () { sync(real(this), 'images'); });
      conSw.on('slideChange', function () { sync(real(this), 'content'); });
      var cur = 0; tabs.some(function (t, k) { if (t.classList.contains('is-active')) { cur = Number(t.dataset.slide); return true; } });
      sync(cur, null);
      if (window.SmAboutParallax) window.SmAboutParallax.refresh();
    }
    root.addEventListener('click', function (e) {
      var tab = e.target.closest('.sm-about-tabs__tab'); if (tab) { sync(Number(tab.dataset.slide), null); return; }
      var next = e.target.closest('.sm-about-tabs__next-btn'); if (next) sync(Number(next.dataset.nextSlide), null);
    });
    root.addEventListener('keydown', function (e) {
      if (!e.target.classList.contains('sm-about-tabs__tab')) return;
      var i = Number(e.target.dataset.slide);
      if (e.key === 'ArrowRight') { e.preventDefault(); sync(i + 1, null); (tabs[(i + 1) % count] || tabs[0]).focus(); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); sync(i - 1, null); (tabs[(i - 1 + count) % count]).focus(); }
    });
    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(build, 200); });
    build();
    if (root.dataset.autoplay === 'true') setInterval(function () { if (imgSw) sync(real(imgSw) + 1, null); }, Number(root.dataset.autoplayDelay) || 5000);
  }
  function all() { document.querySelectorAll('[data-sm-about-tabs]').forEach(init); }
  function boot() { if (window.Swiper) all(); else { var n = 0, t = setInterval(function () { if (window.Swiper || ++n > 100) { clearInterval(t); all(); } }, 50); } }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
